import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import './Commitment.css';
import Storage from '../services/Storage';
import { Roles } from '../constants/Roles';
import { CommonCommitment } from './CommonComponents';

const Commitment = ({ previewData, previewAllData, userId }) => {
  const navigate = useNavigate();
  const location = useLocation();

  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role : '';

  const setBreadcrumbsRecord = () => {
    if (previewAllData.business_name) {
      Storage.setBreadcrumbsrRecord([
        {
          title: 'Preview App',
          url: location.pathname,
        },
        {
          title: previewAllData.business_name,
          url: `/pages/new-dealer/${previewAllData.id}`,
        },
      ]);
    }
  };

  useEffect(() => {
    getCommitData();
  }, [])

  const getCommitData = (obj) => { }
  return (
    <div id='businessCommit'>
      <Row>
        <Col xs={12}>
          <div className='d-flex align-items-center'>
            <div className='main-title'>
              Business Commitment
              {roleName &&
                (
                  (roleName === Roles.TM_NAME && (previewAllData.is_approved === false || (previewAllData.is_approved === true && previewAllData.is_required_kyc === true))
                  )
                  ||
                  (roleName === Roles.BH_NAME && (previewAllData.is_approved === false || (previewAllData.is_approved === true && previewAllData.is_required_kyc === true))
                  )
                  ||
                  (roleName === Roles.SH_NAME &&
                    (previewAllData.is_approved === false || (previewAllData.is_approved === true && previewAllData.is_required_kyc === true)))
                ) ? (
                <i
                  onClick={() => {
                    setBreadcrumbsRecord();
                    navigate(
                      `/pages/business-commitment/${userId}`
                    );
                  }}
                  className='fa fa-edit editButton noprint'
                ></i>
              ) : (
                ''
              )}
            </div>
          </div>
        </Col>
        {previewData.length > 0 && (
          <Col lg={6} md={6}>
            <div className='businessTableBlock'>
              <div className='commitment-title'>
                Business Commitment For Next 3 Financial Year
              </div>
              <CommonCommitment
                userId={userId}
                commitData={getCommitData}
              // upload={upload}
              // handleEditCommitment={handleEditCommitment}
              />
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default React.memo(Commitment);
